import React, { Component } from 'react';
import "./footer.css";
import { NavLink } from "react-router-dom";

export default class extends Component {
  constructor(props) {
      super(props);
  }

  componentDidMount = () => {
  }
  render() {
    return (
      <div className="full-width white-background" style={{minWidth:'100%', paddingBottom:"60px"}}>
        <div className="primary-background" style={{'height':'8px'}}></div>
        <div className="medium-padding">
          <div className="full-width centered-text">
            <NavLink exact to="/">
              <img className="full-width" style={{maxWidth: "300px"}} src="/images/logo-stacked.png" />
            </NavLink>
            <p className="subheading" style={{marginBottom: "30px"}}>{'the place for classical pilates'}</p>
            <a className="tiny-padding" href="https://www.facebook.com/pilatesavenuelosgatos" target="_blank">
              <img className="half-width" style={{maxWidth: "30px"}} src="/images/fb-icon.png" />
            </a>
            <a className="tiny-padding" href="https://www.instagram.com/pilatesavenuelg/" target="_blank">
              <img className="half-width" style={{maxWidth: "30px"}} src="/images/ig-icon.png" />
            </a>
          </div>
          <div className="row small-max-width-container centered-text">
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/">
                  <div className="footer-link  uppercase">
                    {'Home'}
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/services">
                  <div className="footer-link  uppercase">
                    {'Services'}
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/about">
                  <div className="footer-link  uppercase">
                    {'About Us'}
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/formoms">
                  <div className="footer-link  uppercase">
                    {'For Moms'}
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/online">
                  <div className="footer-link  uppercase">
                    {'Online Options'}
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="small-12 medium-4">
              <div className="tiny-padding">
                <NavLink to="/contact">
                  <div className="footer-link  uppercase">
                    {'Contact'}
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js